import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ElementRef, SimpleChanges } from '@angular/core';
import { GridService } from 'app/Shared/Services/grid.service';
import { FormsModule } from '@angular/forms';
import {CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { FormatterComponent } from '../json-viewer/json-formatter.component';
import { PrettyJsonPipe } from '../pipes/prettyjson.pipe';

@Component({
    selector: 'app-quickview-sidebar',
    imports: [DrawerModule, FormsModule, ButtonModule,CommonModule,PrettyJsonPipe],
    templateUrl: './quickview-sidebar.component.html',
    styleUrls: ['./quickview-sidebar.component.scss']
})
export class QuickviewSidebarComponent implements OnInit, OnChanges {
  @Input() columnJSON!: JSON;
  @Input() selectedData: any;
  @Input() display: any;
  @Output() CloseEvent: EventEmitter<boolean> = new EventEmitter<any>();
  quickviewcols: any = [];
  selectedRow: any = [];
  displayDialog: any = false;
  constructor(private eRef: ElementRef,
    private gridService: GridService) { }
  ngOnChanges(changes: SimpleChanges): void {
    this.quickviewcols = this.gridService.ConvertKeysToLowerCase(this.columnJSON);
    let tempArray = this.gridService.ConvertKeysToLowerCase(this.selectedData);
    this.selectedRow[0] = tempArray[0];
  }
  ngOnInit() {
    this.quickviewcols = this.columnJSON;
    this.selectedRow = this.selectedData;
    this.displayDialog = false;
  }
  onHideSideBar() {
    this.CloseEvent.emit(false);
    this.displayDialog = false;
  }
}
